import React, { useGlobal, useState, useCallback, useEffect } from 'reactn';
import { DeliveryItemsStyled } from './DeliveryItems.styled';
import ItemStatusNav from '../../_common/itemStatusNav/ItemStatusNav';
import DeliveryItemCard from '../../_common/deliveryItemCard/DeliveryItemCard';
import { getTrackingHistory } from '../../../services/Api';
import useMyDeliveries from '../../../hooks/useMyDeliveries';
import { ReactComponent as ReceivingImage } from '../../../images/receivingEmptyImg.svg';
import { ReactComponent as SendingImage } from '../../../images/sendingEmptyImg.svg';
import Loader from "shared-anpost-components/components/loader/Loader";
import profileHooks from '../../../hooks/profileHooks';
import DetectDeviceResize from "shared-anpost-components/hooks/detectDeviceResizeHook";
import { ReactComponent as RightArrow } from '../../../images/rightArrow.svg';
import { pushDataLayer } from '../../../helpers/Helpers';
const DeliveryItems = () => {
    const [profile, setProfile] = useGlobal("userProfile");
    const [returnType, setReturnType] = useGlobal("globalReturnType");
    const [trackingItems, setTrackingItems] = useGlobal("trackingItems");
    const [isLoading, setIsLoading] = useState(false);
    const [selectedTrackingItem, setSelectedTrackingItem] = useGlobal("selectedTrackingItem");
    const [selectedTrackingItemDetails, setSelectedTrackingItemDetails] = useGlobal("selectedTrackingItemDetails");
    const [isHistorical, setIsHistorical] = useGlobal("isHistorical");
    const [historyItemsExist, setHistoryItemsExist] = useState(false);

    const { filterReceivingItems, filterSendingItems } = useMyDeliveries(profile);
    const { values } = profileHooks();

    const { isMobile } = DetectDeviceResize();

    const handleHistorical = () => {
        if (!isHistorical) setIsHistorical(true);
        else return
    };


    useEffect(() => {
        if (trackingItems && trackingItems.length > 0) {
            setHistoryItemsExist(trackingItems.some(item => item.isHistorical));
        }
    }, [trackingItems])

    useEffect(() => {
        if (trackingItems && trackingItems.length > 0 && !isMobile) {
            if (returnType === "receiving") {
                if (filterReceivingItems(trackingItems).length) {
                    const firstFilteredItem = filterReceivingItems(trackingItems).sort((a, b) => {
                        if (a.lastTrackingEventCategoryId === "1" && b.role !== "1") {
                            return -1;
                        } else if (a.role !== "1" && b.role === "1") {
                            return 1;
                        } else {
                            return 0;
                        }
                    })[0]

                    setSelectedTrackingItem(firstFilteredItem);

                    getTrackingHistory(values.ciamUserId, firstFilteredItem.trackingNumber).then((res) => {
                        setSelectedTrackingItemDetails(res.data.trackingItemHistories);
                    });
                } else {
                    setSelectedTrackingItem(null);
                }
            } else if (returnType === "sending") {


                if (filterSendingItems(trackingItems).length) {
                    const firstFilteredItem = filterSendingItems(trackingItems).sort((a, b) => {
                        if (a.dateDelivered === null) return -1;
                        if (b.dateDelivered === null) return 1;

                        return new Date(b.dateDelivered) - new Date(a.dateDelivered);

                    })[0]

                    setSelectedTrackingItem(firstFilteredItem);


                    getTrackingHistory(values.ciamUserId, firstFilteredItem.trackingNumber).then((res) => {
                        setSelectedTrackingItemDetails(res.data.trackingItemHistories);
                    });
                } else {
                    setSelectedTrackingItem(null);
                }

            }
        }
    }, [returnType]);

    const handleSelected = useCallback((newState) => {
        if (selectedTrackingItem !== newState) {
            pushDataLayer({
                event: "trackingItem",
                retailer_name: newState.retailerName,
            });
            getTrackingHistory(values.ciamUserId, newState.trackingNumber).then((res) => {
                setSelectedTrackingItemDetails(res.data.trackingItemHistories);
            });
            setSelectedTrackingItem(newState);
        }
    }, []);

    const handleSingularItem = (trackingItems) => {
        if (trackingItems.length === 1) {
            return "item";
        } else {
            return "items";
        }
    };

    const handleMissingSelectedItem = useCallback(() => {
        if (selectedTrackingItem) {
            return selectedTrackingItem.trackingNumber;
        }
        return "";
    }, [selectedTrackingItem]);

    return (
        <DeliveryItemsStyled>
            {isLoading && <Loader />}



            {returnType === "sending" && (
                <div>
                    <div className='itemAmount'>
                        You have <b>{filterSendingItems(trackingItems).length}</b> {handleSingularItem(filterSendingItems(trackingItems))}
                    </div>
                    <div className='itemsPanel'>
                        {filterSendingItems(trackingItems).length > 0 ? filterSendingItems(trackingItems).sort((a, b) => {
                            if (a.dateDelivered === null) return -1;
                            if (b.dateDelivered === null) return 1;

                            return new Date(b.dateDelivered) - new Date(a.dateDelivered);

                        }).map((item, index) => (
                            <DeliveryItemCard
                                isSending={true}
                                key={index}
                                trackingItem={item}
                                handleSelected={handleSelected}
                                selected={handleMissingSelectedItem() === item.trackingNumber}
                            />
                        )) : (
                            <div className='noItemsCardWrapper'>
                                <div>
                                    <SendingImage />
                                    <p>There are no An Post deliveries from you at the moment. You can track an item by entering the tracking number in the box above.</p>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}
            {returnType === "receiving" && (
                <div>
                    <div className='itemAmount'>
                        You have <b>{filterReceivingItems(trackingItems).length}</b> {handleSingularItem(filterReceivingItems(trackingItems))}
                    </div>
                    <div className='itemsPanel'>
                        {filterReceivingItems(trackingItems).length > 0 ? filterReceivingItems(trackingItems).sort((a, b) => {
                            if (a.lastTrackingEventCategoryId === "1" && b.role !== "1") {
                                return -1;
                            } else if (a.role !== "1" && b.role === "1") {
                                return 1;
                            } else {
                                return 0;
                            }
                        }).map((item, index) => (
                            <DeliveryItemCard
                                key={index}
                                trackingItem={item}
                                handleSelected={handleSelected}
                                selected={handleMissingSelectedItem() === item.trackingNumber}
                            />
                        )) : (
                            <div className='noItemsCardWrapper'>
                                <div>
                                    <ReceivingImage />
                                    <p>There are no An Post deliveries for you at the moment. You can track an item by entering the tracking number in the box above.</p>
                                </div>
                            </div>
                        )}
                    </div>
                    {historyItemsExist && <div className='historySection gtm-linkclick' onClick={handleHistorical}>
                        <span>View delivery history</span>
                        <RightArrow />
                    </div>}
                </div>
            )}
        </DeliveryItemsStyled>
    );
};

export default DeliveryItems;
